import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import {
  Save as SaveIcon,
  ArrowBackIos,
} from "@mui/icons-material";
import { Form, Field } from "react-final-form";
import { Button, Checkbox, FormControl, InputLabel, MenuItem, TextField } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import clsx from "clsx";

import { useInMobile } from "themes/Device";
import SkeletonLoader from "components/Loader/SkeletonLoader";
import TextInputMui from "components/TextInputMui";
import { Col, Row } from "react-bootstrap";
//context
import {
  useLayoutDispatch,
  addCurrentScreenTitle,
} from "context/LayoutContext";
import {
  useCouponsQuery,
  useUpdateCouponsClassMutation,
  useCreateCouponsClassMutation,
} from "hooks/react-query/useCoupons";
import { useTranslation } from "react-i18next";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
const PREFIX = 'AddEditCoupons';

const classes = {
  cardCategoryWhite: `${PREFIX}-cardCategoryWhite`,
  cardTitleWhite: `${PREFIX}-cardTitleWhite`,
  formcontrolwidth: `${PREFIX}-formcontrolwidth`,
  root: `${PREFIX}-root`,
  main: `${PREFIX}-main`,
  rowHeight: `${PREFIX}-rowHeight`,
  textfield: `${PREFIX}-textfield`,
  centerProperty: `${PREFIX}-centerProperty`,
  centerButton: `${PREFIX}-centerButton`,
  buttonPosition: `${PREFIX}-buttonPosition`,
  btnSection: `${PREFIX}-btnSection`,
  selectBoxControl: `${PREFIX}-selectBoxControl`,

};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.cardCategoryWhite}`]: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },

  [`& .${classes.cardTitleWhite}`]: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: '"Oxygen", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  [`& .${classes.btnSection}`]: {
    justifyContent: 'center',
    display: 'flex',
    position: 'sticky',
    bottom: '6px',
    background: '#fff'

  },
  [`& .${classes.formcontrolwidth}`]: {
    width: "100%",
  },

  [`&.${classes.root}`]: {
    width: "100%",
    height: "100%",
    [theme.breakpoints.down('md')]: {
      background: "#fff",
      borderRadius: "8px",
      padding: "1rem 0",
    },
  },

  [`& .${classes.main}`]: {
    width: "60%",
  },

  [`& .${classes.rowHeight}`]: {
    height: "100%",
    color: "rgba(0, 0, 0, 0.87)",
    width: "100%",
    border: "0",
    display: "flex",
    position: "relative",
    minWidth: "0",
    background: " #FFF",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
    borderRadius: "6px",
    display: "flex",
  },

  [`& .${classes.textfield}`]: {
    margin: "2%",
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.centerProperty}`]: {
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.centerButton}`]: {
    display: "flex",
    alignItems: "center",
  },

  [`& .${classes.buttonPosition}`]: {
    display: "flex",
    justifyContent: "end",
  },
  [`& .${classes.selectBoxControl}`]: {
    width: "100%",
  },
}));

const AddEditCoupons = (props) => {
  //hooks

  const param = useParams();
  const isMobileView = useInMobile();
  const history = useHistory();

  let { drawerClose } = props;
  const [couponId, setcouponId] = useState(props?.couponId);
  const { data } = useCouponsQuery(couponId);
  const [initialCouponsData, setInitialCouponsData] =
    useState();
  const [submittingBtnProcess, setSubmittingBtnProcess] = useState(false);
  const layoutDispatch = useLayoutDispatch();
  const { t } = useTranslation();

  const { mutate: addCoupons, isLoading: creating } =
    useCreateCouponsClassMutation();
  const { mutate: updateCoupons, isLoading: updating } =
    useUpdateCouponsClassMutation();

  const onSubmit = async (values) => {
    setSubmittingBtnProcess(true);
    if (couponId > 0) {
      updateCoupons({
        variables: {
          id: couponId,
          input: {
            ...values,
          },
        },
      });
    } else {
      addCoupons({
        variables: {
          input: {
            ...values,
          },
        },
      });
    }
    if (!isMobileView && drawerClose) drawerClose();
    else history.push("/app/coupons");
  };

  useEffect(() => {
    let screenTitle = "";
    if (param.id > 0) {
      setcouponId(param.id)
      screenTitle = "Edit Coupon";
    } else {
      screenTitle = "Add Coupon";
    }
    if (isMobileView) {
      addCurrentScreenTitle(layoutDispatch, {
        currentScreenTitle: screenTitle,
      });
      return () => {
        addCurrentScreenTitle(layoutDispatch, { currentScreenTitle: "" });
      };
    }
  }, []);

  useEffect(() => {
    setInitialCouponsData(data);
  }, [data]);

  return (
    <Root className={classes.root}>
      {initialCouponsData || couponId > 0 ? (
        <>
          <Form
            onSubmit={onSubmit}
            initialValues={initialCouponsData}
            validate={(values) => {
              const errors = {};
              if (!values?.code?.trim()) {
                errors.code = t("name-validation-message");
              } else if (values?.code?.length > 50) {
                errors.code = t("maximumlength-validation-message");
              }
              if (values?.description && values?.description?.length > 50) {
                errors.description = t("maximumlength-validation-message");
              }
              return errors;
            }}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
              <form
                onSubmit={(event) => {
                  handleSubmit(event).then(() => {
                    form.reset();
                    form.restart();
                  });
                }}
                className="mt-2"
              >
                <Row className="m-0">
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    className={classes.buttonPosition}
                  ></Col>
                </Row>
                <Row className="m-0">
                  <Col xs={12} sm={12} md={12}>
                    <Field name="code">
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>
                          <TextInputMui
                            {...input}
                            type="text"
                            variant="outlined"
                            label={`${"Code"}${"*"}`}
                            error={meta.error && meta.touched ? true : false}
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>
                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="description">
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>
                          <TextInputMui
                            {...input}
                            type="text"
                            label={"Description"}
                            variant="outlined"
                            error={meta.error && meta.touched ? true : false}
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>
                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="amount">
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>
                          <TextInputMui
                            {...input}
                            type="number"
                            label={"Amount"}
                            variant="outlined"
                            error={meta.error && meta.touched ? true : false}
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>
                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="type">
                      {({ input, meta }) => (
                        <FormControl
                          className={classes.textfield}
                        >
                          <TextInputMui
                            {...input}
                            select
                            label={"Select Coupon Type"}
                            variant="outlined"
                            error={meta.error && meta.touched ? true : false}
                          >
                            {["fixed", "percentage"]?.map((item, index) => (
                              <MenuItem value={item}>{item}</MenuItem>
                            ))}
                          </TextInputMui>
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>

                  </Col>
                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="maximumDiscountUses">
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>
                          <TextInputMui
                            {...input}
                            type="number"
                            label={"Maximun Order Validity"}
                            variant="outlined"
                            error={meta.error && meta.touched ? true : false}
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="priority">
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>
                          <TextInputMui
                            {...input}
                            type="number"
                            label={"Priority"}
                            variant="outlined"
                            error={meta.error && meta.touched ? true : false}
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>

                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="active_from" allowNull={true}>
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              {...input}
                              label={"Active From"}
                              inputFormat="dd/MM/yyyy"
                              renderInput={(params) => <TextField {...params} />}
                              error={meta.error && meta.touched ? true : false}
                            />
                          </LocalizationProvider>

                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>
                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="expire_at" allowNull={true}>
                      {({ input, meta }) => (
                        <FormControl className={classes.textfield}>

                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              {...input}
                              label={"Expire At"}
                              inputFormat="dd/MM/yyyy "
                              renderInput={(params) => <TextField {...params} />}
                              error={meta.error && meta.touched ? true : false}
                            />
                          </LocalizationProvider>
                          {meta.error && meta.touched && (
                            <span style={{ color: "red" }}>{meta.error}</span>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Col>
                  <br></br>
                  <Col xs={12} sm={12} md={12}>
                    <Field name="is_active" type="checkbox">
                      {({ input, meta }) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            color="primary"
                            {...input}
                            style={{ paddingLeft: "0px" }}
                          />
                          <InputLabel
                            htmlFor="is_active"
                            style={{ marginBottom: "0px" }}
                          >
                            {"is Active?"}
                          </InputLabel>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={12}>
                    <div className={classes.btnSection}>
                      <div className="ml-2">
                        <Button
                          variant="outlined"
                          color="secondary"
                          className={classes.button}
                          type="button"
                          onClick={() => {
                            if (isMobileView)
                              history.push("/app/coupons");
                            else if (!isMobileView && drawerClose)
                              drawerClose();
                          }}
                          startIcon={<ArrowBackIos />}
                        >
                          {t("back")}
                        </Button>
                      </div>
                      <div className="ml-2">
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          type="submit"
                          disabled={submitting}
                          startIcon={<SaveIcon />}
                        >
                          {submittingBtnProcess ? t("processing") : t("save")}
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </form>
            )}
          />
        </>
      ) : (
        <SkeletonLoader count={3} height={50} />
      )}
    </Root>
  );
};

export default AddEditCoupons;
